"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.abbreviateNumber = exports.getExplicitISODateStringWithoutZone = exports.getExplicitDateBreakdownWithoutZone = exports.centsToDollars = exports.nl2br = exports.getPhoneNumberE164Format = exports.getPhoneNumberUtil = exports.sentenceCase = void 0;
const google_libphonenumber_1 = require("google-libphonenumber");
const sentenceCase = (value) => {
    return String(value || '')
        .replace(/^[a-z]|[A-Z]|[0-9]/g, (val, index) => {
        return index === 0 ? val.toUpperCase() : ` ${val.toLowerCase()}`;
    })
        .replace(/_/g, ' ');
};
exports.sentenceCase = sentenceCase;
const getPhoneNumberUtil = () => {
    return google_libphonenumber_1.PhoneNumberUtil.getInstance();
};
exports.getPhoneNumberUtil = getPhoneNumberUtil;
const getPhoneNumberE164Format = (phoneNumber, region = 'US') => {
    try {
        const phone = (0, exports.getPhoneNumberUtil)().parse(phoneNumber, region);
        if ((0, exports.getPhoneNumberUtil)().isPossibleNumber(phone)) {
            return (0, exports.getPhoneNumberUtil)().format(phone, google_libphonenumber_1.PhoneNumberFormat.E164);
        }
        return '';
        // Explicit any because of this change:
        // https://devblogs.microsoft.com/typescript/announcing-typescript-4-4/#use-unknown-catch-variables
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
    }
    catch (err) {
        return '';
    }
};
exports.getPhoneNumberE164Format = getPhoneNumberE164Format;
const nl2br = (value) => {
    return (value || '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1<br>$2');
};
exports.nl2br = nl2br;
const centsToDollars = (value) => {
    return value / 100;
};
exports.centsToDollars = centsToDollars;
const getExplicitDateBreakdownWithoutZone = (date) => {
    const year = date.getFullYear();
    const month = `${date.getMonth() + 1}`.padStart(2, '0');
    const day = `${date.getDate()}`.padStart(2, '0');
    const hour = `${date.getHours()}`.padStart(2, '0');
    const minute = `${date.getMinutes()}`.padStart(2, '0');
    const second = `${date.getSeconds()}`.padStart(2, '0');
    return {
        year,
        month,
        day,
        hour,
        minute,
        second,
        fullDateStr: `${year}-${month}-${day}T${hour}:${minute}:${second}`,
    };
};
exports.getExplicitDateBreakdownWithoutZone = getExplicitDateBreakdownWithoutZone;
const getExplicitISODateStringWithoutZone = (date) => {
    const { fullDateStr } = (0, exports.getExplicitDateBreakdownWithoutZone)(date);
    return fullDateStr;
};
exports.getExplicitISODateStringWithoutZone = getExplicitISODateStringWithoutZone;
const defaultOptions = {
    padding: true,
    symbols: ['', 'k', 'M', 'G', 'T', 'P', 'E'],
};
const abbreviateNumber = (num, digit = 1, options) => {
    const { symbols, padding } = Object.assign(Object.assign({}, defaultOptions), options);
    // handle negatives
    const sign = Math.sign(num) >= 0;
    // eslint-disable-next-line no-param-reassign
    num = Math.abs(num);
    // what tier? (determines SI symbol)
    // eslint-disable-next-line no-bitwise
    const tier = (Math.log10(num) / 3) | 0;
    // if zero, we don't need a suffix
    if (tier === 0)
        return (!sign ? '-' : '') + num.toString();
    // get suffix and determine scale
    const suffix = symbols[tier];
    if (!suffix)
        throw new RangeError();
    // eslint-disable-next-line no-restricted-properties
    const scale = Math.pow(10, tier * 3);
    // scale the number
    const scaled = num / scale;
    let rounded = scaled.toFixed(digit);
    if (!padding) {
        rounded = String(Number(rounded));
    }
    // format number and add suffix
    return (!sign ? '-' : '') + rounded + suffix;
};
exports.abbreviateNumber = abbreviateNumber;
//# sourceMappingURL=format.js.map